import { IThemeStorage } from '@app/common/Theme/ThemeContext';
import Image from 'next/image';

import type { IconName } from '@helpers/constants/icons';
import getIcon from '@helpers/constants/icons';

type IconProps = {
  name: IconName;
  themeName?: string;
  theme?: IThemeStorage;
  width?: number;
  height?: number;
  loading?: 'lazy' | 'eager';
};

function Icon(props: IconProps): JSX.Element {
  const currentTheme = process.env.NEXT_PUBLIC_THEME_ALIAS || 'light-theme';
  const themeNameFallback = currentTheme === 'light-theme' ? 'light' : 'blackFriday';
  const { name, themeName = themeNameFallback, ...otherProps } = props;

  const imageProps = getIcon({
    name,
    themeName,
    hostname: process.env.NEXT_PUBLIC_HTTP_DOMAIN,
  });

  if (imageProps) {
    return <Image {...imageProps} {...otherProps} />;
  }

  return null;
}

export default Icon;
